import { Grid } from "@material-ui/core";
import { FileList } from "./components/file-list";
import { FileUploader } from "./components/file-uploader";

type Props = {
  consultantId: string;
};

export const FilesTab = ({ consultantId }: Props) => {
  return (
    <Grid container spacing={6}>
      <Grid item xs={6}>
        <FileUploader consultantId={consultantId} />
      </Grid>
      <Grid item xs={6}>
        <FileList consultantId={consultantId} />
      </Grid>
    </Grid>
  );
};
